var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0511 29.1022C22.8113 29.1022 29.1022 22.8113 29.1022 15.0511C29.1022 7.29089 22.8113 1 15.0511 1C7.29089 1 1 7.29089 1 15.0511C1 22.8113 7.29089 29.1022 15.0511 29.1022Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8262 13.0152C12.484 13.0152 13.0174 12.4818 13.0174 11.824C13.0174 11.1661 12.484 10.6328 11.8262 10.6328C11.1683 10.6328 10.635 11.1661 10.635 11.824C10.635 12.4818 11.1683 13.0152 11.8262 13.0152Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8188 13.8125H10.8335C10.724 13.8125 10.635 13.9014 10.635 14.011V19.9669C10.635 20.0765 10.724 20.1654 10.8335 20.1654H12.8188C12.9284 20.1654 13.0174 20.0765 13.0174 19.9669V14.011C13.0174 13.9014 12.9284 13.8125 12.8188 13.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7351 13.479C17.8866 13.1883 16.8252 13.4436 16.1887 13.9014C16.1669 13.8161 16.0891 13.7525 15.9966 13.7525H14.0113C13.9017 13.7525 13.8127 13.8415 13.8127 13.9511V19.9069C13.8127 20.0165 13.9017 20.1055 14.0113 20.1055H15.9966C16.1061 20.1055 16.1951 20.0165 16.1951 19.9069V15.6267C16.5159 15.3503 16.9292 15.2622 17.2675 15.4059C17.5955 15.5445 17.7833 15.8828 17.7833 16.3334V19.9069C17.7833 20.0165 17.8723 20.1055 17.9818 20.1055H19.9671C20.0767 20.1055 20.1657 20.0165 20.1657 19.9069V15.9336C20.143 14.3021 19.3755 13.6982 18.7351 13.479Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin-white.7475a355fce8597054e0a58b5e0eff3b.svg";
export { ForwardRef as ReactComponent };